export default __webpack_public_path__ + "static/media/gallery-wip-crystal-chamber_01.b73a785c.jpg";